import React from 'react';
import {oneOfType, number, element, any, arrayOf, bool, func, shape, string} from 'prop-types';
import {Checkbox, Form, Grid} from 'semantic-ui-react';
import {FormattedMessage} from 'react-intl';
import concat from 'lodash/concat';
import without from 'lodash/without';
import includes from 'lodash/includes';
import {range} from 'utils/DBUtils';

export default class BasicCheckbox extends React.Component {
  static propTypes = {
    className: string,
    colCount: number,
    colWidth: number, // width for Semantic Grid.Column
    label: string,
    options: arrayOf(
      shape({
        key: any,
        value: any.isRequired,
        text: oneOfType([string, element]),
        textKey: string
      })
    ),
    value: any.isRequired,
    required: bool,
    boolean: bool, // render only a single checkbox, representing a boolean value.
    name: string.isRequired,
    onValueChanged: func.isRequired
  };

  static defaultProps = {
    className: '',
    colWidth: 6,
    options: []
  };

  toggleBooleanCheckbox = (event, {checked}) => {
    this.props.onValueChanged(checked);
  };

  toggleCheckbox = (event, {value, checked}) => {
    const prevValue = this.props.value || [];
    const nextValue = checked ? concat(prevValue, value) : without(prevValue, value);
    this.props.onValueChanged(nextValue);
  };

  get colCount() {
    if (this.props.colCount) {
      return this.props.colCount;
    } else {
      return this.props.options.length > 1 ? 2 : this.props.options.length; // 2 cols max
    }
  }

  render() {
    if (this.props.boolean && this.props.options.length === 1) {
      const option = this.props.options[0];

      const label = (
        <label htmlFor={this.props.name}>
          {option.textKey ? <FormattedMessage id={option.textKey} /> : option.text}
        </label>
      );

      return (
        <Form.Field className={this.props.className}>
          <Checkbox
            key={option.key || option.value}
            label={label}
            disabled={option.disabled}
            name={this.props.name}
            required={this.props.required}
            value={option.value}
            checked={this.props.value === option.value || option.preChecked}
            onChange={this.toggleBooleanCheckbox} />
        </Form.Field>
      );
    }

    return (
      <Form.Field className={this.props.className}>
        {this.props.label}
        <Grid>
          <Grid.Row>
            {range(this.colCount).map(colIndex => {
              const optionsByColumn = this.colCount > 1 ? this.props.options.reduce((result, option, index) => {
                const i = index % 2;
                if (!result[i]) {
                  result[i] = [];
                }
                result[i].push(option);
                return result;
              }, {}) : {[colIndex]: this.props.options};

              return (
                <Grid.Column width={this.props.colWidth} key={colIndex}>
                  {optionsByColumn[colIndex].map(option => (
                    <Grid key={option.key}>
                      <Grid.Row>
                        <Checkbox
                          key={option.key || option.value}
                          label={
                            <label htmlFor={this.props.name}>
                              {option.textKey ? <FormattedMessage id={option.textKey} /> : option.text}
                            </label>
                          }
                          disabled={option.disabled === true}
                          name={this.props.name}
                          required={this.props.required}
                          value={option.value}
                          checked={includes(this.props.value, option.value) || option.preChecked}
                          onChange={this.toggleCheckbox} />
                      </Grid.Row>
                    </Grid>
                  ))}
                </Grid.Column>
              );
            })}
          </Grid.Row>
        </Grid>
      </Form.Field>
    );
  }
}



// WEBPACK FOOTER //
// ./public/components/forms/BasicFormFields/Checkbox.js